import { MinimumWorkspace } from '@repo/api-client';
import { H6 } from '@repo/ui-kit/components/core/Typography';

import { NameWrapper } from './styles';

type WorkspaceNameProps = {
  workspace: MinimumWorkspace;
};

export const WorkspaceName: React.FC<WorkspaceNameProps> = ({ workspace }) => {
  return (
    <NameWrapper>
      <H6 bold textOverflowEllipsis>
        {workspace.name}
      </H6>
    </NameWrapper>
  );
};
